import { useMutation } from "@tanstack/react-query";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";

export interface CloneActionPayload {
  newName: string;
}

export interface CloneActionResponse {
  id: string;
  action: string;
}

export async function cloneAction(
  projectUuid: string, 
  selectedActionId: string, 
  label: string,
  payload: CloneActionPayload,
  token: string
): Promise<CloneActionResponse> {
  const url = `${config.isometricApiUrl}/functional-graph/${projectUuid}/clone-node/${selectedActionId}/${label}`;
  try {
    const response = await apiFetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error cloning action:", error);
    throw error;
  }
}

export const useCloneAction = (
  onSettled?: (res: CloneActionResponse | undefined, error: Error | null) => void
) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: {
      projectUuid: string;
      selectedActionId: string;
      label: string;
      body: CloneActionPayload;
    }) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace('Bearer ', '');
      return cloneAction(payload.projectUuid, payload.selectedActionId, payload.label, payload.body, token);
    },
    onSettled
  });
};